import { useCallback, useRef, useState } from "react";

/**
 * Track whether an element is being hovered over with useHover.
 */
export const useHover = <T extends HTMLElement = HTMLElement>(): [(node: T | null) => void, boolean] => {
	const [isHovering, setIsHovering] = useState(false);
	const cleanupRef = useRef<(() => void) | null>(null);

	const ref = useCallback((node: T | null) => {
		cleanupRef.current?.();
		cleanupRef.current = null;

		if (node === null) {
			setIsHovering(false);
			return;
		}

		const onEnter = () => setIsHovering(true);
		const onLeave = () => setIsHovering(false);

		node.addEventListener("mouseenter", onEnter);
		node.addEventListener("mouseleave", onLeave);

		cleanupRef.current = () => {
			node.removeEventListener("mouseenter", onEnter);
			node.removeEventListener("mouseleave", onLeave);
		};
	}, []);

	return [ref, isHovering];
};
